import { render, staticRenderFns } from "./AiGenerateDocModal.vue?vue&type=template&id=9905e830&scoped=true"
import script from "./AiGenerateDocModal.vue?vue&type=script&lang=js"
export * from "./AiGenerateDocModal.vue?vue&type=script&lang=js"
import style0 from "./AiGenerateDocModal.vue?vue&type=style&index=0&id=9905e830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9905e830",
  null
  
)

export default component.exports